import { formatDistanceToNow } from "date-fns";

export function timeAgo(iso) {
  try {
    return formatDistanceToNow(new Date(iso), { addSuffix: true });
  } catch {
    return "";
  }
}

export const REACTIONS = [
  { type: "hug", label: "Hug", emoji: "🫂", bg: "#FDF0E6", text: "#D48A54", border: "#F8CDB0" },
  { type: "support", label: "Support", emoji: "🌱", bg: "#E6EBE4", text: "#6D7A6A", border: "#CCD5C9" },
  { type: "heart", label: "Heart", emoji: "💛", bg: "#FBEAE7", text: "#D97B6A", border: "#F5C7C0" },
];

const HUE = ["#CCD5C9", "#F8CDB0", "#F5C7C0", "#B3C0AE", "#DEDFDB", "#E6EBE4"];
export function handleColor(handle = "") {
  let sum = 0;
  for (let i = 0; i < handle.length; i++) sum += handle.charCodeAt(i);
  return HUE[sum % HUE.length];
}
